export function sendToDevice(data) {
    if (window && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appnative) {
        window.webkit.messageHandlers.appnative.postMessage(data);
    }

    if (window && window.AppNative) {
        window.AppNative.sendMessage(JSON.stringify(data));
    }
}
